import { createApp } from "vue";
import "@/lib/_jquery";
import * as UILibrary from "@assemblyvoting/electa-ui"; // Imports components
import "@assemblyvoting/electa-ui/styles"; // Imports styles
import { debounce } from "ts-debounce";
import { PiniaDebounce } from "@pinia/plugin-debounce";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { useSharedStore } from "@/entrypoints/stores/shared";
import { usePresentationStore } from "@/entrypoints/stores/presentation";
import { useServerConnectionStore } from "@/entrypoints/stores/server_connection";
import i18n from "./shared/i18n_backend";
import { createPinia } from "pinia";
import VueSelect from "vue-select";
// Components
import RevealableInfo from "@/components/shared/RevealableInfo.vue";
import ImporterProgressBar from "@/components/backend/ImporterProgressBar.vue";
import ContestImporterProgressBar from "@/components/backend/ContestImporterProgressBar.vue";
import ImageSelector from "@/components/backend/ImageSelector.vue";
import CampaignTemplateSelector from "@/components/backend/CampaignTemplateSelector.vue";
import CampaignControls from "@/components/backend/CampaignControls.vue";
import Live from "@/components/backend/Live.vue";
import ExclusiveInputs from "@/components/backend/ExclusiveInputs.vue";
import VoterSecrets from "@/components/backend/VoterSecrets.vue";
import VoterFormSecrets from "@/components/backend/VoterFormSecrets.vue";
import TranslationsEditor from "@/components/backend/TranslationsEditor.vue";
import MessageLocalContent from "@/components/backend/messages/MessageLocalContent.vue";
import AllowedDomains from "@/components/backend/election_config/access/AllowedDomains.vue";
import StatisticsSegments from "@/components/backend/election_config/statistics/StatisticsSegments.vue";
import Result from "@/components/frontend/shared/Result.vue";
import BoardProgressBar from "@/components/backend/BoardProgressBar.vue";
import ContestSelectionList from "@/components/backend/ContestSelectionList.vue";
import BallotPreview from "@/components/backend/BallotPreview.vue";
import PresentationPreview from "@/components/backend/PresentationPreview.vue";
import ElectionCopierProgress from "@/components/backend/ElectionCopierProgress.vue";
import CandidacyCopierProgress from "@/components/backend/candidacy/CandidacyCopierProgress.vue";
import VotingRoundReportProgress from "@/components/backend/VotingRoundReportProgress.vue";
import PageBuilder from "@/components/backend/candidacy/PageBuilder.vue";
import FormBuilder from "@/components/backend/candidacy/FormBuilder.vue";
import JumbotronRenderer from "@/components/shared/JumbotronRenderer.vue";
import IconSelector from "@/components/backend/candidacy/page_builder/IconSelector.vue";
import ResourceProfile from "@/components/shared/candidacy/ResourceProfile.vue";
import PartyProfile from "@/components/shared/candidacy/PartyProfile.vue";
import ApprovalRequestsList from "@/components/shared/candidacy/ApprovalRequestsList.vue";
import ThresholdCeremony from "@/components/backend/ThresholdCeremony.vue";
import ResultCeremony from "@/components/backend/ResultCeremony.vue";
import ContestSelectionForm from '@/components/backend/prefilled_ballots/ContestSelectionForm.vue';
import ContestSelectionSummary from '@/components/backend/prefilled_ballots/ContestSelectionSummary.vue';
const SimpleComponents = {
  "revealable-info": RevealableInfo,
  "importer-progress-bar": ImporterProgressBar,
  "contest-importer-progress-bar": ContestImporterProgressBar,
  "image-selector": ImageSelector,
  "campaign-template-selector": CampaignTemplateSelector,
  "campaign-controls": CampaignControls,
  "exclusive-inputs": ExclusiveInputs,
  "voter-secrets": VoterSecrets,
  "voter-form-secrets": VoterFormSecrets,
  "translations-editor": TranslationsEditor,
  "message-local-content": MessageLocalContent,
  "allowed-domains": AllowedDomains,
  "statistics-segments": StatisticsSegments,
  "result": Result,
  "board-progress-bar": BoardProgressBar,
  "contest-selection-list": ContestSelectionList,
  "ballot-preview": BallotPreview,
  "presentation-preview": PresentationPreview,
  "voting-round-report-progress": VotingRoundReportProgress,
  "election-copier-progress": ElectionCopierProgress,
  "page-builder": PageBuilder,
  "form-builder": FormBuilder,
  "jumbotron-renderer": JumbotronRenderer,
  "icon-selector": IconSelector,
  "resource-profile": ResourceProfile,
  "party-profile": PartyProfile,
  "approval-requests-list": ApprovalRequestsList,
  "candidacy-copier-progress": CandidacyCopierProgress,
  "threshold-ceremony": ThresholdCeremony,
  "result-ceremony": ResultCeremony,
  "contest-selection-form": ContestSelectionForm,
  "contest-selection-summary": ContestSelectionSummary,
}

$(function() {
  Object.entries(SimpleComponents).forEach(([tag, component]) => {
    $(`[data-vue-component=${tag}]`).each(function() {
      const propsData = $(this).data("vue-props");
      const app = createApp(component, propsData);
      app.component("v-select", VueSelect)
      app.use(i18n);
      app.use(UILibrary.default, i18n);
      app.mount(this);
    });
  });

  $('[data-vue-component="live"]').each(function() {
    const election = JSON.parse(this.getAttribute("data-election"));
    const electionUrl = this.getAttribute("data-url");
    const electionLocales = JSON.parse(this.getAttribute("data-locales"));
    const readonly = this.getAttribute("data-readonly") === "true";

    const app = createApp(Live);
    const pinia = createPinia();
    pinia.use(piniaPluginPersistedstate);
    pinia.use(PiniaDebounce(debounce));
    app.use(pinia);
    app.use(i18n);

    app.use(UILibrary.default, i18n);

    const sharedStore = useSharedStore();
    const presentationStore = usePresentationStore();
    const serverConnectionStore = useServerConnectionStore();

    sharedStore.setElectionUrl(electionUrl);
    sharedStore.setLocales(electionLocales);
    sharedStore.setElection(election); // store.commit('setElection', {...election, userModules: {}});
    presentationStore.setSlides([]);
    presentationStore.setReadonly(readonly);

    window.onunhandledrejection = (event: PromiseRejectionEvent) => {
      const error = event.reason;
      if (!error.response) {
        // display connection warning
        serverConnectionStore.connectionFailed();
        event.preventDefault();
      } else if (error.response.status === 401 && [11].includes(error.response.data.code)) { // [11: invalidAuthenticityToken]
        // the admin's authenticity token has expired (likely because their session has expired)
        if (confirm((i18n as any).$t("js.backend.live.invalid_authenticity_token_confirm_reload"))) {
          window.location.reload();
        }
        event.preventDefault();
      } else if (error.response.status === 403) {
        presentationStore.showToast({
          header: (i18n as any).$t("js.toasts.error.request_denied"),
          body: error.response.data.message,
          duration: 5,
          classes: {
            header: "bg-danger text-white",
            body: "",
          },
        });
        event.preventDefault();
      }
    }

    app.mount('[data-vue-component="live"]');
  })
});

$(function() {
  const vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  // We listen to the resize event
  window.addEventListener("resize", () => {
    // We execute the same script as before
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  });
});
